module.exports = __webpack_public_path__ + "img/logo.d13379ff.png";